import { html, TemplateResult, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import globalStyles from './styles/outline-fad-about-section.global.pcss?inline';
import encapsulatedStyles from './styles/outline-fad-about-section.inner.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { SlotHelper } from '../../controllers/slot-helper';

const componentName = 'outline-fad-about-section';

/**
 * The OutlineFadAboutSection component
 * @element outline-fad-about-section
 */
@customElement('outline-fad-about-section')
export class OutlineFadAboutSection extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });
  private _slotHelper = new SlotHelper(this);

  @property({ type: Boolean })
  hasDetail: boolean;

  @property({ type: Boolean })
  hasVideo: boolean;

  @property({ type: Boolean })
  hasDescription: boolean;

  render(): TemplateResult {
    this.hasDetail = this._slotHelper.isNotEmpty('detail');
    this.hasVideo = this._slotHelper.isNotEmpty('video');
    this.hasDescription = this._slotHelper.isNotEmpty('description');

    return html`
      <div class="outline-fad-about-section">
        <div class="heading">
          <slot name="heading"></slot>
        </div>
        ${this.hasDetail
          ? html`
              <div class="details">
                <slot name="detail"></slot>
              </div>
            `
          : null}
        ${this.hasVideo
          ? html`
              <div class="video">
                <slot name="video"></slot>
              </div>
            `
          : null}
        ${this.hasDescription
          ? html`
              <div class="description">
                <slot name="description"></slot>
              </div>
            `
          : null}
      </div>
    `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineFadAboutSection;
  }
}
